module.exports = __webpack_public_path__ + "img/euro_normal_skoda.6b5f7159.svg";